import qs from "qs";
import * as auth from "auth-provider";
import { useCallback } from "react";
import axiosIns, { getHeaders } from "./request";
import { AxiosRequestConfig } from "axios";
import { message } from "antd";
import { getLanguage } from "auth-provider";
import { LabelType } from "screens/register/page-header";

export const POS_API_URL = process.env.REACT_APP_POS_URL;
export const CHOWBUS_API_URL = process.env.REACT_APP_CHOWBUS_URL;
export const CHOWBUS_MONOLITH_API_URL = process.env.REACT_APP_CHOWBUS_API_URL;

const lang = getLanguage() as LabelType;

const defaultErrorMsgObj = {
  en: { error: "invalid_request", error_description: "Network Error." },
  zh: { error: "无效请求", error_description: "系统繁忙" },
};

const timeoutMsgObj = {
  en: {
    error: "invalid_request",
    error_description: "The request timed out, please try again later.",
  },
  zh: { error: "无效请求", error_description: "请求超时，请稍后再试" },
};
export interface Config extends AxiosRequestConfig {
  token?: string;
  data?: { [key in string]: unknown } | { [key in string]: unknown }[];
}
// endpoint: 链接后缀
// 加 ={}，让参数成为一个可选参数
export const http = async (
  endpoint: string,
  { data, token, headers, ...customConfig }: Config = {}
) => {
  const config: Config = {
    method: "get",
    headers: headers ? headers : getHeaders(),
    ...customConfig,
  };

  let urlParam = `${endpoint}`;
  // get 请求，参数拼在链接里；非get请求，(post, delete)请求等，参数放在body里
  const method = config.method;
  // debugger
  if (method === "get") {
    urlParam = `${urlParam}?${qs.stringify(data)}`;
  } else {
    Object.assign(config, { data: JSON.stringify(data || {}) });
  }
  return axiosIns(urlParam, config)
    .then(async (response) => {
      const data = await response.data;
      // 此时，请求已经retry过一次
      if (response.status === 401 || response.status === 400 || response.status === 403) {
        auth.logout();
        const linkParam = auth.getLinkParams();
        window.location.href =
          window.location.origin + `/member?${qs.stringify(linkParam)}`;
      }
      if (response.status === 200 || response.status === 204) {
        return Promise.resolve(data || { success: true });
      } else {
        return Promise.reject(data);
      }
    })
    .catch((e) => {
      if ((e && e.error && e.error_description) || e.errors) {
        return Promise.reject(e);
      }
      if (e.toString().includes("timeout")) {
        return Promise.reject(timeoutMsgObj[lang]);
      }
      return Promise.reject(defaultErrorMsgObj[lang]);
    });
};

export const useHttp = () => {
  return useCallback((...[endpoint, config]: Parameters<typeof http>) => {
    return http(endpoint, { ...config });
  }, []);
};

export const showErrorMsg = (e: any, callback?: () => void) => {
  if (typeof e !== "object") {
    return;
  }
  if (e.errors) {
    const errors = e.errors;
    if (Array.isArray(errors) && errors.length) {
      const msg = errors.map((item) => item?.title).join(";");
      message.error(msg);
      callback && callback();
    }
  } else if (e.error_description && typeof e.error_description === "string") {
    message.error(e.error_description);
    callback && callback();
  }
};

export const getErrorMsg = (e: any) => {
  if (typeof e !== "object") {
    return defaultErrorMsgObj[lang].error_description;
  }
  if (e.errors) {
    const errors = e.errors;
    if (Array.isArray(errors) && errors.length) {
      const msg = errors.map((item) => item?.title).join(";");
      return msg;
    }
  } else if (e.error_description && typeof e.error_description === "string") {
    return e.error_description;
  } else {
    return defaultErrorMsgObj[lang].error_description;
  }
};
